__turbopack_context__.v({
  "downloadButton": "styles-module-scss-module__oKS3Ia__downloadButton",
  "downloadIcon": "styles-module-scss-module__oKS3Ia__downloadIcon",
});
